let map,
    popup,
    standPopup,
    Popup;

const selectors = {
    map          : document.getElementById('map'),
    originInput  : document.getElementById('origin-input'),
    destinInput  : document.getElementById('destination-input'),
    destinStand  : document.getElementById('destination-stand-input'),
    submit       : document.getElementById('submit-local'),
    popup        : 'popup',
    standPopup   : 'popup-stand',
    popupWrapper : '.popup-bubble-anchor'
};

const cssClasses = {
    error : 'error',
    open  : 'is-open'
};

let directionsService = null;
let directionsDisplay = null;

export default function initMap() {
    if(selectors.map.classList.contains('map-loaded')){
        return;
    }

    directionsService = new google.maps.DirectionsService;
    directionsDisplay = new google.maps.DirectionsRenderer;

    let bounds = new google.maps.LatLngBounds();


    ['popup', 'popup-stand'].forEach(function(elemPopup){
        if(document.getElementById(elemPopup)){
            document.getElementById(elemPopup).classList.remove('hide');
        }
    });

    selectors.map.classList.add('map-loaded');


    definePopupClass();

    map = new google.maps.Map(selectors.map, {
        disableDefaultUI : true,
        clickableIcons   : false,
        zoom             : 16
    });

    directionsDisplay.setMap(map);

    if (productGeoLocation !== null) {
        popup = new Popup(
            new google.maps.LatLng(productGeoLocation.lat, productGeoLocation.lng), document.getElementById(selectors.popup)
        );
        
        bounds.extend(new google.maps.LatLng(productGeoLocation.lat, productGeoLocation.lng));
        popup.setMap(map);

        if (!document.getElementById(selectors.standPopup)) popup.anchor.querySelector(selectors.popupWrapper).classList.add(cssClasses.open);

        popup.anchor.addEventListener('click', function() {
            if (standPopup) standPopup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
    
            this.querySelector(selectors.popupWrapper).classList.toggle(cssClasses.open);
            map.panTo({ lat: productGeoLocation.lat, lng: productGeoLocation.lng });
            map.setZoom(16);
        });
    }

    if (standGeoLocation !== null) {
        if (standGeoLocation.lat !== productGeoLocation.lat || standGeoLocation.lng !== productGeoLocation.lng) {
            standPopup = new Popup(
                new google.maps.LatLng(standGeoLocation.lat, standGeoLocation.lng), document.getElementById(selectors.standPopup)
            );
            
            bounds.extend(new google.maps.LatLng(standGeoLocation.lat, standGeoLocation.lng));
            standPopup.setMap(map);
            
            popup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
    
            standPopup.anchor.addEventListener('click', function() {
                if (popup) popup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
                
                this.querySelector(selectors.popupWrapper).classList.toggle(cssClasses.open);
                map.panTo({ lat: standGeoLocation.lat, lng: standGeoLocation.lng });
                map.setZoom(16);
            });
        }
    }
    
    if (standPopup) {
        map.fitBounds(bounds, { top: 130 });
    } else {
        map.panTo(bounds.getCenter());
    }

    const autocomplete = new google.maps.places.Autocomplete(selectors.originInput);
    autocomplete.bindTo('bound', map);
    
    if(selectors.submit){
        selectors.submit.addEventListener('click', () => calculateAndDisplayRoute());
    }
    
    window.addEventListener('keydown', (evt) => {
        if (evt.key === 'Enter' || evt.keyCode === 13) calculateAndDisplayRoute();
    });

    map.addListener('click', () => {
        if (popup && standPopup) map.fitBounds(bounds, { top: 130 });
        if (popup) popup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
        if (standPopup) standPopup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
    });
}

function definePopupClass() {
    Popup = function(position, content) {
        this.position = position;

        const pixelOffset = document.createElement('div');
        pixelOffset.classList.add('popup-bubble-anchor');
        pixelOffset.appendChild(content);

        this.anchor = document.createElement('div');
        this.anchor.classList.add('popup-tip-anchor');
        this.anchor.appendChild(pixelOffset);

        this.stopEventPropagation();
    }

    Popup.prototype = Object.create(google.maps.OverlayView.prototype);

    Popup.prototype.onAdd = function() {
        this.getPanes().floatPane.appendChild(this.anchor);
    };

    Popup.prototype.draw = function() {
        const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
       
        const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';
    
        if (display === 'block') {
          this.anchor.style.left = divPosition.x + 'px';
          this.anchor.style.top = divPosition.y + 'px';
        }

        if (this.anchor.style.display !== display) {
          this.anchor.style.display = display;
        }
    }

    Popup.prototype.stopEventPropagation = function() {
        let anchor = this.anchor;
        anchor.style.cursor = 'auto';
    
        ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown'].forEach(function(event) {
            anchor.addEventListener(event, function(e) {
                e.stopPropagation();
            });
        });
    };
}

function calculateAndDisplayRoute() {
    if (selectors.destinInput) requestDirections(selectors.destinInput.value);
    if (selectors.destinStand) requestDirections(selectors.destinStand.value);
}

function renderDirections(result) {
    let directionsRenderer = new google.maps.DirectionsRenderer;
    
    directionsRenderer.setMap(map);
    directionsRenderer.setDirections(result);
}

function requestDirections(end) {
    directionsService.route({
        origin      : selectors.originInput.value,
        destination : end,
        travelMode  : 'DRIVING',
        // waypoints   : [{ location: { lat: standGeoLocation.lat, lng: standGeoLocation.lng } }],
    }, (response, status) => {
        if (status === 'OK') {
            renderDirections(response);
            if (popup) popup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
            if (standPopup) standPopup.anchor.querySelector(selectors.popupWrapper).classList.remove(cssClasses.open);
        } else {
            selectors.originInput.classList.add(cssClasses.error);
        }
    });
}
